import { UI_FIELD_KEY, UI_WIDGET_KEY } from "../constants";
import getSchemaType from "../getSchemaType";
import getUiOptions from "../getUiOptions";
import isCustomWidget from "../isCustomWidget";
import isFilesArray from "./isFilesArray";
import isMultiSelect from "./isMultiSelect";
/** Determines whether the combination of `schema` and `uiSchema` properties indicates that the label for the `schema`
 * should be displayed in a UI.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param schema - The schema for which the display label flag is desired
 * @param [uiSchema={}] - The UI schema from which to derive potentially displayable information
 * @param [rootSchema] - The root schema, used to primarily to look up `$ref`s
 * @param [globalOptions={}] - The optional Global UI Schema from which to get any fallback `xxx` options
 * @returns - True if the label should be displayed or false if it should not
 */

export default function getDisplayLabel(validator, schema) {
  var uiSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var rootSchema = arguments.length > 3 ? arguments[3] : undefined;
  var globalOptions = arguments.length > 4 ? arguments[4] : undefined;
  var uiOptions = getUiOptions(uiSchema, globalOptions);
  var _uiOptions$label = uiOptions.label,
      label = _uiOptions$label === void 0 ? true : _uiOptions$label;
  var displayLabel = !!label;
  var schemaType = getSchemaType(schema);

  if (schemaType === 'array') {
    displayLabel = isMultiSelect(validator, schema, rootSchema) || isFilesArray(validator, schema, uiSchema, rootSchema) || isCustomWidget(uiSchema);
  }

  if (schemaType === 'object') {
    displayLabel = false;
  }

  if (schemaType === 'boolean' && !uiSchema[UI_WIDGET_KEY]) {
    displayLabel = false;
  }

  if (uiSchema[UI_FIELD_KEY]) {
    displayLabel = false;
  }

  return displayLabel;
}